import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    currentModal: null,
};
const layoutSlice = createSlice({
    name: 'ui/layout',
    initialState,
    reducers: {
        showModal: (state, action) => {
            state.currentModal = action.payload;
        },
        hideModal: (state) => {
            state.currentModal = null;
        },
    },
});
// Export actions - maintains backward compatibility
export const { showModal, hideModal } = layoutSlice.actions;
// Export reducer as default - maintains backward compatibility
export default layoutSlice.reducer;
